(function () {
  'use strict';

  var nav = document.querySelector('nav');
  var scrollTopBtn = document.querySelector('.scroll-top');
  var scrollTopVisible = false;
  var ticking = false;

  function onScroll() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (nav) {
      if (scrollY > 100) {
        nav.classList.add('shrinked');
      }
      if (scrollY < 30) {
        nav.classList.remove('shrinked');
      }
    }

    if (scrollTopBtn) {
      if (scrollY > 250 && !scrollTopVisible) {
        scrollTopBtn.style.display = 'block';
        scrollTopVisible = true;
      } else if (scrollY <= 250 && scrollTopVisible) {
        scrollTopBtn.style.display = 'none';
        scrollTopVisible = false;
      }
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
